import * as React from 'react';
import { MapPreview as KitMapPreview } from '@redhand/ui';
import { t } from '@reos/i18n';
import { mapyApiKey } from '../lib/mapy.js';
import { WIZARD_TEXTS } from '../lib/texts.js';

/**
 * Nahled mapy s vyznacenim bodu adresy (BLOK 5). Od kroku C2 je samotna
 * komponenta v kitu (`@redhand/ui`) — tady zustava jen dosazeni textu
 * z i18n a klice z env. Atribuce se NIKDY neskryva (licencni podminka).
 */
export function MapPreview({
  lat,
  lon,
  center,
  onPick,
}: {
  readonly lat: number | null;
  readonly lon: number | null;
  /**
   * Krok DEMO2: stred vyrezu, kdyz presny bod neni znamy — mapa se vykresli
   * odzoomovana a BEZ bodu (kit, `MapPreviewProps.center`). Pouziva se pro
   * vyrez obce na karte zakazky bez geokodovane adresy.
   */
  readonly center?: { readonly lat: number; readonly lon: number } | undefined;
  /** Krok M1: klik do mapy -> navrh parcely (zakazka-novy.tsx). */
  readonly onPick?: ((lat: number, lon: number) => void) | undefined;
}): React.JSX.Element {
  const texts = React.useMemo(
    () => ({
      mapyAttribution: t('webAdmin.mapPreview.attribution', { locale: 'cs' }),
      osmAttribution: t('webAdmin.mapPreview.osmAttribution', { locale: 'cs' }),
      unavailable: WIZARD_TEXTS.mapUnavailable,
      regionLabel: t('webAdmin.mapPreview.regionLabel', { locale: 'cs' }),
    }),
    [],
  );
  return (
    <KitMapPreview
      lat={lat}
      lon={lon}
      apiKey={mapyApiKey()}
      texts={texts}
      testIdPrefix="wizard"
      center={center}
      onPick={onPick}
    />
  );
}
